import styled from 'styled-components'
// themes
import { BottomPaper } from 'themes/views/settings'

export const Form = styled.form`
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;

  ${BottomPaper} {
    flex-shrink: 0;
    margin: 0;

    button {
      margin-right: 16px;
    }
  }
`

export const Content = styled.div`
  padding: 20px;
  display: flex;
  flex: 1;
  min-height: 0;
  gap: 16px;
  flex-direction: column;
  overflow: auto;

  > div:first-child {
    flex-basis: 0;
  }
`
